import { createSlice } from "@reduxjs/toolkit";
import { userService } from "../services/users.service";
import { openSnackBar } from "./snackBarReducer";
import {logout} from './authReducer';

//reducers
export const userSlice = createSlice({
    name: "user",
    initialState: {
        updatingUser: false,
        deletingUser: false,
        gettingUserData: true,
        user: {},
        get_user: {},
        submitted: 0
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setUpdatingUser: (state, action) => {
            state.updatingUser = action.payload === undefined ? false : action.payload;
        },
        setGettingUserData: (state, action) => {
            state.gettingUserData = action.payload === undefined ? false : action.payload;
        },
        setDeletingUser: (state, action) => {
            state.deletingUser = action.payload === undefined ? false : action.payload;
        },
        setGetUser: (state, action) => {
            state.get_user = action.payload
        }
    }
});

export const { setUser, setDeletingUser, setUpdatingUser, setGetUser, setGettingUserData } = userSlice.actions;


//selectors
export const selectUser = (state) => state.userState.user;


export default userSlice.reducer;